/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $(document).foundation(); // Foundation JavaScript

        Foundation.DropdownMenu.defaults.closeOnClick = true;

        var fade = true;
        var timeout;

        function toggleMenu() {

          $(this).toggleClass('open');
          $('.top-balken').toggleClass('open');
          $('.mobile-menu').toggleClass('open');
          $('body').toggleClass('no-scroll');
          $('#toggle-menu').toggleClass('active');
        }

        $('[data-dropdown-menu]').on('show.zf.dropdownmenu', function() {
          if(fade){
            $('#menu-background').fadeIn(300);
          }
          fade = false;
          window.clearTimeout(timeout);
        });

        $('[data-dropdown-menu]').on('hide.zf.dropdownmenu', function() {
          timeout = setTimeout(function(){
            $('#menu-background').fadeOut(300);
            fade = true;
          }, 300);
        });

        $('#toggle-menu').click(function(){
          toggleMenu();

          return false;
        });


        $('.icon-close').click(function(){
          $('.menu-item').blur();
          $('.submenu ').removeClass('js-dropdown-active');
          $('[aria-selected="true"]').attr("aria-selected","false");
          timeout = setTimeout(function(){
            $('#menu-background').fadeOut(300);
            fade = true;
          }, 100);
          return false;
        });

        $('.mobile-menu .menu-item:not(.menu-item-has-children):not(.menu-item-object-custom) > a').click(function(){

          $('#toggle-menu').removeClass('open');
          $('.top-balken').removeClass('open');
          $('.mobile-menu').removeClass('open');
          $('.content').fadeTo( 50, 0.0 );
          $('footer').fadeTo( 50, 0.0 );

        });

        $('.mobile-menu .menu-item-object-custom > a').click(function(){

          //$('#toggle-menu').removeClass('open');
          //$('.top-balken').removeClass('open');
          //$('.mobile-menu').removeClass('open');
          //$('body').toggleClass('no-scroll');

        });

        $('.mobile-menu .menu-item-has-children > a').click(function(){
          var i = 0;
          var parent = $(this).parent();
          $('.mobile-menu ul > li').each(function(){
            if($('.mobile-menu ul > li').index(parent)!==i){
              $(this).removeClass('open');
              $(this).find('*').removeClass('open');
            }
            i++;
          });
          $(this).parent().toggleClass('open');
          $(this).toggleClass('open');
          $(this).siblings('.foldable-content').toggleClass('open');
          return false;
        });

        $('.mobile-menu .menu-item-has-children > a').each(function(){
          var text = $(this).text();
          text = text.replace(' ','<br>');
          $(this).html(text);
        });

        $('.hero a[href^="#"], .startscreen a[href^="#"]').on('click', function(e) {
          e.preventDefault();
          var target = this.hash,
            $target = $(target);
          $('html, body').stop().animate({
            'scrollTop': $target.offset().top
          }, 900, 'swing', function() {
            window.location.hash = target;
          });
        });

        if ( window.location.hash ) {
          var hash = window.location.hash,
            $hash = $(hash);

          $hash.removeAttr('id');
          $hash.before('<div id="'+hash.slice(1)+'" class="hashlink"></div>');
          window.location.hash = hash;
          //$('html, body').animate({
          //    scrollTop: $hash.offset().top + 'px'
          //}, 1000);

        }

        $('.dropdown.menu.show-for-large a').on('click', function(e) {
          if($(this).attr('href') === '#') {
            e.preventDefault();
            e.stopPropagation();
          }
        });

        var menuCloseTimer;

        $("#menu-main > .menu-item-has-children,#menu-main-englisch > .menu-item-has-children,#menu-main-es > .menu-item-has-children").mouseover(function() {
          $(".sub-menu").hide();
          var _ = $(this);
          _.find(".sub-menu").show();
          clearTimeout(menuCloseTimer);

        });

        $("#menu-main > .menu-item-has-children, #menu-main-englisch > .menu-item-has-children, #menu-main-es > .menu-item-has-children").mouseleave(function() {

          menuCloseTimer = setTimeout(function(){  $(".sub-menu").hide(); }, 300);

        });

        $("#flyout-abdecker, #logo, #navi-home, #navi-kontakt, #lupe").mouseover(function() {
          $("#flyout-abdecker").css("opacity","1");

          $(".sub-menu").hide();
          $("#navi-flyout1").removeClass("hover");
          $("#navi-flyout2").removeClass("hover");
          $("#navi-flyout3").removeClass("hover");

        });


        // Suche

        $("#suchfeld").hide();

        $("a#lupe-trigger, #suchfeld a#close").click(function() {
          $("#flyout-abdecker").toggleClass("stable");
          $("#suchfeld").toggle();
          $("#suchfeld input#sucheingabe").focus();
          $("#lupe-trigger").toggleClass("active");
          return false;
        });

        $("#navi-flyout1, #navi-flyout2, #navi-flyout3").mouseover(function() {
          $("#flyout-abdecker").removeClass("stable");
        });

        $("#flyout-abdecker").click(function() {
          $("#flyout-abdecker").removeClass("stable");
          $("#lupe").removeClass("active");
          $("#suchfeld").hide();
        });


        // Language-Menue

        $("#footer-language-menue").hide();

        $("#footer-language a").click(function() {
          $("#footer-language a").toggleClass("active");
          $("#footer-language-menue").toggle();
        });

        if (Foundation.MediaQuery.atLeast('medium')) {
          $('#gf-zitat blockquote').flowtype({
            minFont : 12,
            maxFont : 24,
            fontRatio : 15
          });

        }

        if (Foundation.MediaQuery.current === 'small') {
          $('.reveal').addClass('full');
        }

        $('input').ezMark();

        $('.about-slider').slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000
        });

        if ($('.category-header-menu-item').hasClass('active')) {
          $('#menu-item-1378').addClass('current_page_item');
        }

        $("img").removeAttr("title");

        $(document).on('click','.js-videoPoster',function(ev) {
          $(".play-button").addClass('hide-play');
          $(".videoPoster").addClass('hide-play');
          ev.preventDefault();
          var $poster = $(this);
          var $wrapper = $poster.closest('.js-videoWrapper');
          videoPlay($wrapper);
        });

        function videoPlay($wrapper) {
          var $iframe = $wrapper.find('.js-videoIframe');
          var src = $iframe.data('src');
          $wrapper.addClass('videoWrapperActive');
          $iframe.attr('src',src);
        }

        function videoStop($wrapper) {
          if (!$wrapper) {
            $('.js-videoWrapper');
            $('.js-videoIframe');
          } else {
            $wrapper.find('.js-videoIframe');
          }
          $wrapper.removeClass('videoWrapperActive');
          $iframe.attr('src','');
        }

        $('body').on('added_to_cart',function(){
          if ( !$('#top-balken').hasClass('active-shop') ) {
            $('#top-balken').addClass('active-shop');
          }
          if ( !$('#shop-header').hasClass('active-shop') ) {
            $('#shop-header').addClass('active-shop');
          }
          $(".cart-symbol").addClass("active");
          $(".cart-symbol").addClass("busy");
        });

        $('body').on('added_to_cart',function(e,data) {
          if ($('#hidden_cart').length === 0) { //add cart contents only once
            $(this).append('<div id="hidden_cart_overlay" class="reveal-overlay" style="display: block;" data-closable><div id="hidden_cart_overlay_inner"><div id="hidden_cart"><button id="hidden_cart_close-button" class="close-button" aria-label="Close" type="button" data-close><span aria-hidden="true">&times;</span></button><p class="lead">Sie haben einen Artikel hinzugefügt:</p>'+data['div.widget_shopping_cart_content']+'</div></div></div>');
          }
        });

        $('.tabs-title:first-child a').click();
        $(".tabs-title a:not(:first-child)").click(function(){

          $('.tabs-panel:first-child').attr('aria-selected', 'false');
          $('.tabs-panel:first-child').removeClass("is-active");
          $(".tabs-title a").attr('aria-selected', 'false');
        });

        $('.tabs-title:first-child a').attr('aria-selected', 'true');
        $('.tabs-panel:first-child').addClass("is-active");

        // custom hide range price on full selection
        $( ".single_variation_wrap" ).on( "show_variation", function ( event, variation ) {
          $(".range-price").addClass("hide-custom-range");
        } );

        $( ".single_variation_wrap" ).on( "hide_variation", function ( event, variation ) {
          $(".range-price").removeClass("hide-custom-range");
        } );

// Custom Shipping Text
        $( ".woocommerce-checkout #billing_country_field strong" ).after( "<div class='country-custom-text'><span>Kunden außerhalb Deutschlands: </span>Bitte nutzen Sie unser <a href='http://www.sanpack.de/kontakt/'>Kontaktformular</a> oder rufen Sie an.</div>" );
        $( ".woocommerce-checkout #shipping_country_field strong" ).after( "<div class='country-custom-text'><span>Kunden außerhalb Deutschlands: </span>Bitte nutzen Sie unser <a href='http://www.sanpack.de/kontakt/'>Kontaktformular</a> oder rufen Sie an.</div>" );


      },
      finalize: function() {


        // JavaScript to be fired on all pages, after page specific JS is fired

        window.addEventListener("pageshow", function(evt){
          if(evt.persisted){
            setTimeout(function(){
              window.location.reload();
            },10);
          }
        }, false);

      },
      resize: function() {

        function equalHeight(group) {
          var tallest = 0;
          group.css('height','auto'); //otherwise only works once!
          group.each(function() {
            var thisHeight = $(this).height();
            if(thisHeight > tallest) {
              tallest = thisHeight;
            }
          });
          group.height(tallest);
        }

        if (Foundation.MediaQuery.atLeast('medium')) {
          equalHeight($(".howto-desc p"));
          equalHeight($(".description-wrap"));
          equalHeight($(".product-col .inner"));
        }

        if(window.matchMedia("(max-width: 678px)").matches) {
          var textboxHeight = $('#service-key-wrap .spalte-links').height();
          var imageboxHeight = $('#service-key-wrap #service-keyvisual').height();
          var newHeight = textboxHeight + imageboxHeight +20;
          $('#service-key-wrap').css({height:newHeight});
        } else {
          if (Foundation.MediaQuery.atLeast('large')) {
            $('#service-key-wrap').css({height:'630px'});
          } else {
            $('#service-key-wrap').css({height:'810px'});
          }
        }


        // Tabs to Accordeon
        function tabToAccordeonCheck(){
          var rwd_tabs      = $('.responsive-tabs') ;
          var toggl_type    = $('.toggleType') ;
          var tab_wrap      = $('.tab-wrap');
          var tab_title     = $('.tabs-title');
          var active_tab    = $('.tabs .is-active');

          // small only
          if (Foundation.MediaQuery.current === 'small'){
            if ( rwd_tabs.hasClass('tabs-content') ) {
              tab_wrap.css('display', 'none');
              rwd_tabs.removeClass('tabs-content');
              rwd_tabs.addClass('accordion');
              toggl_type.addClass('accordion-item');
              tab_wrap.addClass('accordion-content');
              rwd_tabs.attr('data-accordion');
              toggl_type.removeClass('tabs-panel');
              $('.toggleType.is-active').children('.tab-wrap').css('display', 'block');
            }

            $('.accordion-title').on('click', function() {
              $(this).children('tab-wrap').css('display', 'none');
              var shared_id = $(this).attr('id') ;
              $('.tabs-title.is-active').removeClass('is-active');
              $('ul.tabs li.' + shared_id).addClass('is-active');
              $('.tabs-title.is-active a').attr('aria-selected', 'true');
            });
          }

          // medium
          else {
            if ( rwd_tabs.hasClass('accordion') ) {
              rwd_tabs.removeAttr('data-accordion');
              rwd_tabs.removeClass('accordion');
              tab_wrap.removeClass('accordion-content');
              toggl_type.removeClass('accordion-item');
              rwd_tabs.addClass('tabs-content');
              toggl_type.addClass('tabs-panel');
              tab_wrap.css('display', '');
            }
          }

        }

        tabToAccordeonCheck();

        // Kontakt-, Anfrage-, Rueckruf- und FAQ Formular

        // reingedrueckte optik der checkbox-bereiche bei Klick
        $(".muster-wahl input[type='checkbox']").change(function() {
          $(this).closest("label").toggleClass("selected", this.checked);
        });
        // nach aktualisieren auch noch reingedruckt sein
        $(".muster-wahl input[type=checkbox]:checked").each(
          function() {
            $(this).closest("label").addClass("selected");
          });

        // muster-produkte ausblenden
        $("#muster-wahl-wrap").hide();

        // muster-produkte einblenden
        $("input#gratismuster").change(function() {
          $("#muster-wahl-wrap").fadeToggle(300);
        });
        // nach aktualisieren sollen die muster-produkte sichtbar sein
        if( $('input#gratismuster').attr('checked')){
          $("#muster-wahl-wrap").show();
        }

        // muster-produkte einblenden
        $("input#gratismuster").change(function() {

          $(".muster-wahl input").toggleClass("required");

          $("input#firma").toggleClass("required");
          $("input#vorname").toggleClass("required");
          $("input#nachname").toggleClass("required");
          $("input#strasse").toggleClass("required");
          $("input#hausnummer").toggleClass("required");
          $("input#plz").toggleClass("required");
          $("input#ort").toggleClass("required");
          $("input#land").toggleClass("required");
          $("input#telefonnummer").toggleClass("required");

          $("textarea#nachricht").toggleClass("required");
        });

        // required zuweisen wenn gratismuster gewuenscht
        if( $('input#gratismuster').attr('checked')){

          // mindestens ein produkttyp muss angegeben sein
          $(".muster-wahl input").addClass("required");

          // nach aktualisieren sollen adressangaben pflicht sein
          $("input#firma").addClass("required");
          $("input#vorname").addClass("required");
          $("input#nachname").addClass("required");
          $("input#strasse").addClass("required");
          $("input#hausnummer").addClass("required");
          $("input#plz").addClass("required");
          $("input#ort").addClass("required");
          $("input#land").addClass("required");
          $("input#telefonnummer").addClass("required");

          // nach aktualisieren soll nachricht optional sein
          $("textarea#nachricht").removeClass("required");
        }
        // asdf
        $("input#gratismuster").change(function() {
          $("label.error").hide();
          $(".error").removeClass("error");
        });

        // Error message localization
        if(SiteParameters.wpml_current_lang === 'de') {

          $gratismuster = "<div>Bitte w&auml;hlen Sie mindestens ein Produkt aus.</div>";
          $mailreq = "Bitte geben Sie Ihre E-Mail-Adresse ein.";
          $mailvalid = "Die E-Mail-Adresse ist ung&uuml;tig.";
          $maillenght = "Bitte geben Sie eine g&uuml;ltige E-Mail-Adresse ein.";
          $firma = "Bitte geben Sie die Firma an.";
          $nachricht = "Bitte geben Sie eine Nachricht ein.";
          $vorname = "Bitte geben Sie Ihren Vornamen ein.";
          $nachname = "Bitte geben Sie Ihren Nachnamen ein.";
          $strasse = "Bitte geben Sie Ihre Straße ein.";
          $hausnummer = "Die Nr. fehlt.";
          $plz = "Die PLZ fehlt.";
          $ort = "Bitte geben Sie den Ort an.";
          $land = "Bitte geben Sie das Land ein.";
          $telefonnummer = "Bitte geben Sie Ihre Telefonnummer an.";
          $recaptchamessage = "Bitte bestätigen Sie, dass Sie kein Roboter sind.";
          $datamessage = "Bitte akzeptieren Sie die Datenschutzerklärung.";

        } else {

          $gratismuster = "<div>Please choose at least one product.</div>";
          $mailreq = "This field is required.";
          $mailvalid = "This e-mail address is invalid.";
          $maillenght = "Please enter a valid e-mail address.";
          $firma = "This field is required.";
          $nachricht = "This field is required.";
          $vorname = "This field is required.";
          $nachname = "This field is required.";
          $strasse = "This field is required.";
          $hausnummer = "Nr. is required.";
          $plz = "This field is required.";
          $ort = "This field is required.";
          $land = "This field is required.";
          $telefonnummer = "This field is required.";
          $recaptchamessage = "Please confirm, you are not a robot.";
          $datamessage = "Please accept the privacy policy.";

        }

        $("#anfrage").validate({
          /* focusInvalid: false,*/
          invalidHandler: function(form, validator) {

            if (!validator.numberOfInvalids()) {
              return;
            }
            $('html, body').animate({
              scrollTop: $(validator.errorList[0].element).offset().top-130
            }, 400);

          },

          validHandler: function(form, validator) {

            $('html, body').animate({ scrollTop: "0" });

          },
          ignore: ".ignore",
          rules: {
            "hiddenRecaptcha": {
              required: function() {
                if(grecaptcha.getResponse() === '') {
                  console.log('Captcha is not Passed');
                  return true;
                } else {
                  console.log('Captcha is Passed');
                  return false;

                }
              }
            },
            Email: {
              // required: true,
              email: true
            },
            PLZ: {
              // required: true,
              // postalcode: true
            }
          },

          messages: {
            "hiddenRecaptcha": {
              required: $recaptchamessage
            },
            "Gratismuster[]": $gratismuster,
            "Datenschutz[]": $datamessage,
            Email: {
              required: $mailreq,
              email: $mailvalid,
              minlength: $maillenght
            },
            Firma: $firma,
            Nachricht: $nachricht,
            Vorname: $vorname,
            Nachname: $nachname,
            Strasse: $strasse,
            Hausnummer: $hausnummer,
            PLZ: {
              required: $plz,
              // postalcode: "Die PLZ ist ung&uuml;ltig.",
            },
            Ort: $ort,
            Land: $land,
            Telefonnummer: $telefonnummer
          },
        });

        $('#anfrage').ajaxForm(function() {
          $("#anfrage").fadeOut(10);
          $("#datenschutz-hinweis").fadeOut(10);
          $(".kontakt-form .headline").fadeOut(10);
          $(".kontakt-form #content-text").fadeOut(10);
          $("#kontakt-erfolg").fadeIn(10);
          $('html, body').animate({ scrollTop: "0" });

          //ga('send', 'event', 'Kontaktformular', 'Verschickt', '<?php echo get_permalink( $post->ID ); ?>');

        });


      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        if (Foundation.MediaQuery.atLeast('medium')) {
          $('.show-for-medium .home-slider-headline').flowtype({
            minFont : 12,
            maxFont : 70,
            fontRatio : 13
          });
        }

        //$('.home-slider').slick({
        //  dots: true,
        //  infinite: true,
        //  speed: 1500,
        //  slidesToShow: 1,
        //  slidesToScroll: 1,
        //  arrows: false,
        //  autoplay: true,
        //  autoplaySpeed: 3000
        //});



      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
      resize: function() {

        if (Foundation.MediaQuery.current === 'small'){
          $('.seo-wrap .mobile-toggle').on('click', function() {
            if ($(this).hasClass('active')) {
              $(this).removeClass('active');
              $('.seo-readmore-content').slideUp( "fast", function() {
                $('.headline-structure-read-more').fadeIn( "slow" );
              });                         
            } else {
              $(this).addClass('active');
              $('.headline-structure-read-more').fadeOut( "fast", function() {
                $('.seo-readmore-content').slideDown( "slow" ); 
              });
            }
          });
        }


        if (Foundation.MediaQuery.atLeast('medium')) {
          $('.show-for-medium .home-slider-headline').flowtype({
            minFont : 12,
            maxFont : 70,
            fontRatio : 13
          });
        }

        $('.home-slider').slick({
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000
        });

      }
    },
    // Contact Page
    'page_template_page_kontakt': {
      init: function() {

      },
      finalize: function() {

      },
      resize: function() {

      }
    },
    // Anfrage Page
    'page_template_page_anfrage': {
      init: function() {

      },
      finalize: function() {

      },
      resize: function() {

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
        UTIL.fire(classnm, 'resize');
      });


      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
      UTIL.fire('common','resize');
    },
    resizeEvents: function() {

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'resize');
      });

      UTIL.fire('common','resize');

    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
  $(window).on("load",UTIL.windowLoadEvents);

  // Resize Events
  var trackWindowWidth = $(window).width();

  $(window).resize(function (trackResizeEvent) {
      //console.log(!trackResizeEvent.isTrigger ? ' resize' : ' triggerd');
  
      // Check window width has actually changed and it's not just iOS triggering a resize event on scroll || the resize event was caused by $(window).trigger('resize');
      if (($(window).width() !== trackWindowWidth) || trackResizeEvent.isTrigger) {
          // Update the window width for next time
          trackWindowWidth = $(window).width();

          UTIL.resizeEvents();
      }  
  });  

})(jQuery); // Fully reference jQuery after this point.


/*
* FlowType.JS v1.1
* Copyright 2013-2014, Simple Focus http://simplefocus.com/
*
* FlowType.JS by Simple Focus (http://simplefocus.com/)
* is licensed under the MIT License. Read a copy of the
* license in the LICENSE.txt file or at
* http://choosealicense.com/licenses/mit
*
* Thanks to Giovanni Difeterici (http://www.gdifeterici.com/)
*/

(function($) {
  $.fn.flowtype = function(options) {

// Establish default settings/variables
// ====================================
    var settings = $.extend({
        maximum   : 9999,
        minimum   : 1,
        maxFont   : 9999,
        minFont   : 1,
        fontRatio : 35
      }, options),

// Do the magic math
// =================
      changes = function(el) {
        var $el = $(el),
          elw = $el.width(),
          width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
          fontBase = width / settings.fontRatio,
          fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
        $el.css('font-size', fontSize + 'px');
      };

// Make the magic visible
// ======================
    return this.each(function() {
      // Context for resize callback
      var that = this;
      // Make changes upon resize
      $(window).resize(function(){changes(that);});
      // Set changes on load
      changes(this);
    });
  };
}(jQuery));
